import { UsersTypes } from './users-action';

export const initialState = {
  usersList: [],
  usersListToShow: [],
  loading: false,
  paginationLoading: false,
  filterModal: false,
  filters: {
    province: {
      id: undefined,
      value: undefined,
    },
    workHour: {
      id: undefined,
      value: undefined,
    },
    serviceType: {
      id: undefined,
      value: undefined,
    },
    specialty: {
      id: undefined,
      value: undefined,
    },
    specialtiesType: {
      id: undefined,
      value: undefined,
    },
    search: {
      id: undefined,
      value: undefined,
    },
  },
  specialtiesTypeTitle: undefined,
  csr: false,
  lastPage: undefined,
  currentPage: 0,
  selectedUserId: undefined,
  selectedUserLoading: false,
  selectedUserServiceId: undefined,
  selectedUserSlug: undefined,
  userDetails: {
    userContacts: undefined,
    userFirstAppointment: undefined,
  },
  expanded: false,
  searchResult: [],
  searchLoading: false,
  searchValue: '',
};

function usersReducer(state = initialState, action: any) {
  switch (action.type) {
    case UsersTypes.SET_USERS_LIST:
      return {
        ...state,
        usersList: [...action?.data?.usersList],
        usersListToShow: state.currentPage === 0 ? action?.data?.usersList.splice(10) : [...action?.data?.usersList],
        paginationLoading: false,
        loading: false,
        lastPage: action?.data?.lastPage || undefined,
        currentPage: state.currentPage === 0 ? 2 : action?.data?.currentPage || undefined,

      };

    case UsersTypes.GET_EXTENDED_USERS:
      return {
        ...state,
        paginationLoading: true,
        csr: true,
      };

    case UsersTypes.SWITCH_FILTER_MODAL:
      return {
        ...state,
        filterModal: action?.data?.filterModal,
      };

    case UsersTypes.SET_FILTER_ITEMS:

      return {
        ...state,
        filters: {
          ...state.filters,
          [action?.data?.key]: {
            id: action?.data?.id,
            value: action?.data?.value,
          },
        },
        specialtiesTypeTitle: action?.data?.specialtiesTypeTitle || state.specialtiesTypeTitle,
        paginationLoading: true,
        currentPage: initialState.currentPage,
        usersList: initialState.usersList,
        loading: true,
        csr: true,
      };

    case UsersTypes.RESET_FILTER_ITEMS:
      return {
        ...state,
        filters: initialState.filters,
        specialtiesTypeTitle: undefined,
        usersList: [],
        csr: false,
        currentPage: 0,
        lastPage: undefined,
      };

    case UsersTypes.GET_USER_DETAILS:
      return {
        ...state,
        userDetails: initialState.userDetails,
        selectedUserLoading: true,
        selectedUserSlug: action?.data?.selectedUserSlug,
      };

    case UsersTypes.SET_USER_CONTACT:
      return {
        ...state,
        selectedUserId: action?.data?.selectedUserId,
        userDetails: {
          userContacts: action?.data?.userContacts || undefined,
        },

      };

    case UsersTypes.SET_USER_SERVICE_ID:
      return {
        ...state,
        selectedUserServiceId: action?.data?.selectedUserServiceId || undefined,
      };

    case UsersTypes.SET_USER_FIRST_APPOINTMENT:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          userFirstAppointment: action.data?.userFirstAppointment || undefined,
        },
        selectedUserLoading: false,
      };

    case UsersTypes.SET_USER_ITEM_LOADING:
      return {
        ...state,
        selectedUserLoading: false,
      };

    case UsersTypes.SET_USER_ITEM_EXPANDED:
      return {
        ...state,
        expanded: action?.data?.expanded,
      };

    case UsersTypes.DELETE_FILTER_TAG:

      return {
        ...state,
        filters: {
          ...state.filters,
          [action?.data?.key]: {
            id: undefined,
            value: undefined,
          },
        },
        specialtiesTypeTitle: action?.data?.specialtiesTypeTitle || state.specialtiesTypeTitle,
        paginationLoading: true,
        currentPage: initialState.currentPage,
        usersList: initialState.usersList,
        loading: true,
        csr: true,
      };

    case UsersTypes.SET_USER_SEARCH_LIST:
      return {
        ...state,
        searchResult: action?.data || [],
        searchLoading: false,
      };

    case UsersTypes.GET_USER_SEARCH_LIST:
      return {
        ...state,
        searchValue: action?.data?.searchValue || initialState.searchValue,
        searchLoading: true,
      };

    case UsersTypes.SET_SEARCH_LOADING:
      return {
        ...state,
        searchLoading: action?.data?.searchLoading,
      };

    default:
      return state;
  }
}

export default usersReducer;
